import { Button, Modal, Menu, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import ListIcon from "@mui/icons-material/List";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { applicantEligibilityStatus } from "../../../Constants";
import Progress from "./Progress";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setColleagues, setProposal } from "../../../../../store/proposalSlice";
import service from "../../../Helpers/gifservices";
import { setApplicant, setAs } from "../../../../../store/applicantsSlice";

const useStyles = makeStyles((theme) => ({
  button: {
    marginBottom: 2,
    justifyContent: "left",
  },
  approveButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
  },
  declineButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.red.hover,
    },
    color: theme.palette.gif.red.color,
    backgroundColor: theme.palette.gif.red.background,
  },
  changeDecisionButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
}));

const TableActions = (props) => {
  const classes = useStyles();
  const {
    actionsType,
    updateApplicantStatus,
    applicantId,
    createPDF,
    proposalId,
  } = props;
  const [openProgress, setOpenProgress] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const gotoProposal = () => {
    service.getProposalData(proposalId).then(async (proposal) => {
      const propsosalApplicants = await service.getProposalsApplicants({
        proposalId,
      });
      const retrivedApplicants = propsosalApplicants.applicantsDetails.map(
        (ad) => ({
          email: ad.emailadress,
          name: ad.applicant.name,
          id: ad.applicant.id,
        })
      );
      const proposalLeaderEmail = retrivedApplicants.filter(
        (a) => a.id === proposal.applicantLeaderId
      )[0].email;

      dispatch(setApplicant({}));
      dispatch(setProposal(proposal));
      dispatch(setColleagues(retrivedApplicants));
      dispatch(setAs(proposalLeaderEmail));
      history.push("/applicantsportal");
    });
  };
  const ApproveDeclineButtons = () => (
    <>
      <Button
        fullWidth
        startIcon={<CheckIcon />}
        className={`${classes.approveButton} ${classes.button}`}
        onClick={() =>
          updateApplicantStatus(
            applicantId,
            applicantEligibilityStatus.approvedByRA
          )
        }
      >
        Approve
      </Button>
      <Button
        fullWidth
        startIcon={<CloseIcon />}
        className={`${classes.declineButton} ${classes.button}`}
        onClick={() =>
          updateApplicantStatus(
            applicantId,
            applicantEligibilityStatus.declinedByRA
          )
        }
      >
        Decline
      </Button>
    </>
  );
  const DefaultButtons = () => (
    <Button
      fullWidth
      startIcon={<HistoryRoundedIcon />}
      className={`${classes.changeDecisionButton} ${classes.button}`}
      onClick={() =>
        updateApplicantStatus(
          applicantId,
          applicantEligibilityStatus.ChangeDecision
        )
      }
    >
      Change Decision
    </Button>
  );
  const ExtraButtons = () => {
    switch (actionsType) {
      case "approved":
      case "decline":
        return <DefaultButtons />;
      default:
        return <ApproveDeclineButtons />;
    }
  };
  return (
    <>
      <ExtraButtons />
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        fullWidth
        color="primary"
        variant="contained"
      >
        Other
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            gotoProposal();
          }}
        >
          <ListItemIcon>
            <ListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View Proposal" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            setOpenProgress(!openProgress);
          }}
        >
          <ListItemIcon>
            <WatchLaterRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Progress" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            createPDF();
          }}
        >
          <ListItemIcon>
            <PictureAsPdfRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View PDF" />
        </MenuItem>
      </Menu>

      <Modal open={openProgress} onClose={() => setOpenProgress(false)}>
        <Progress proposalId={proposalId} />
      </Modal>
    </>
  );
};

export default TableActions;
